module.exports = __webpack_public_path__ + "img/gsws_1.914d8c62.png";